<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Digitális munkarend elrendelése</ion-title>
    <ion-buttons slot="end"><ion-button (click)="bezar()">Bezár</ion-button></ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p class="sug">Tantermen kívüli, digitális munkarend (Nkt. 27. § (1), (2a)): az érintett osztályok óráin a tanítás és a
    tanulás online, személyes találkozás nélkül folyik. A tanév rendje szerinti időszakban (2026/2027: május 3–7.) a
    <b>gimnázium és a szakgimnázium 9–11. évfolyamán</b> az igazgató döntése szerint <b>szervezhető</b> – nem kötelező.
    Az elrendelés a naplóban és a napló nyomtatványán jelölést ad, a szülők és a tanulók a kezdőlapjukon látják.</p>

  <div class="kozep" *ngIf="toltodik"><ion-spinner></ion-spinner></div>
  <div class="hiba" *ngIf="hiba">{{ hiba }}</div>

  <!-- A már rögzített időszakok (a bejegyzéshez, vagy az egész tanévre). -->
  <ng-container *ngIf="!toltodik && meglevok.length">
    <h3>Már elrendelve</h3>
    <ion-list lines="full" class="meglevok">
      <ion-item *ngFor="let x of meglevok">
        <ion-icon slot="start" name="laptop-outline" color="primary"></ion-icon>
        <ion-label class="ion-text-wrap">
          <h3>{{ x.tol }}{{ x.ig !== x.tol ? ' – ' + x.ig : '' }}</h3>
          <p>{{ osztalyNevek(x) }}</p>
          <p class="halvany" *ngIf="x.ok || x.jogalap">{{ x.ok }}{{ x.ok && x.jogalap ? ' · ' : '' }}{{ x.jogalap }}</p>
          <p class="halvany" *ngIf="x.rogzitette_nev || x.rogzitette">Rögzítette: {{ x.rogzitette_nev || x.rogzitette }}</p>
        </ion-label>
        <ion-button *ngIf="szerkesztheto" slot="end" fill="clear" color="danger" (click)="torol(x)" title="Visszavonás">
          <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
  </ng-container>

  <p class="halvany" *ngIf="!toltodik && !szerkesztheto">Az elrendelés az igazgató döntése: rögzíteni és visszavonni
    adminisztrátor (naptár-admin) tud. Te megnézni tudod.</p>

  <ng-container *ngIf="!toltodik && szerkesztheto">
    <h3>Új elrendelés</h3>
    <div class="sor">
      <ion-input label="Kezdete *" label-placement="stacked" fill="outline" type="date" [(ngModel)]="tol" (ionChange)="tolValtozott()"></ion-input>
      <ion-input label="Vége *" label-placement="stacked" fill="outline" type="date" [(ngModel)]="ig"></ion-input>
    </div>

    <div class="cimsor">Évfolyamok <span class="halvany">(a rendelet szerint 9–11.)</span></div>
    <div class="evfolyamok">
      <ion-checkbox *ngFor="let e of evfolyamLista" [(ngModel)]="valasztottEvf[e]" labelPlacement="end">{{ e }}.</ion-checkbox>
      <span class="halvany" *ngIf="!evfolyamLista.length">Ebben a tanévben nincs osztály – előbb a tanévet kell előkészíteni.</span>
    </div>

    <div class="cimsor">További osztályok egyenként</div>
    <ng-select appendTo="body" [items]="kulonOsztalyok" bindLabel="nev" bindValue="id" [multiple]="true"
               [closeOnSelect]="false" [(ngModel)]="valasztottOsztalyok" groupBy="evfolyam"
               [notFoundText]="'Nincs (minden osztály évfolyamként kijelölve)'" placeholder="Osztály választása">
      <ng-template ng-optgroup-tmp let-item="item">{{ item.evfolyam }}. évfolyam</ng-template>
    </ng-select>

    <ion-input class="mezo" label="Az elrendelés oka / az igazgató döntése" label-placement="stacked" fill="outline" [(ngModel)]="ok"></ion-input>
    <ion-input class="mezo" label="Jogalap" label-placement="stacked" fill="outline" [(ngModel)]="jogalap"
               placeholder="pl. 1/2026. (VII. 31.) OGYM rendelet 5. §"></ion-input>

    <div class="elonezet">
      <b>Érintett osztályok ({{ erintettOsztalyok.length }}):</b>
      <span *ngFor="let o of erintettOsztalyok; let u = last">{{ o.nev }}{{ u ? '' : ', ' }}</span>
      <span class="halvany" *ngIf="!erintettOsztalyok.length">nincs kijelölve</span>
    </div>
    <p class="halvany">A mulasztás számítása nem változik: a jelenlét ilyenkor az online részvételt jelenti – aki nem vesz
      részt az online órán, azt a szokásos módon hiányzónak kell jelölni.</p>
  </ng-container>
</ion-content>
<ion-footer *ngIf="!toltodik && szerkesztheto">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="bezar()">Bezár</ion-button>
      <ion-button fill="solid" color="primary" (click)="ment()" [disabled]="!menthetoE">
        <ion-icon slot="start" name="laptop-outline"></ion-icon>{{ fut ? 'Mentés…' : 'Elrendelés' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
